import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
`;

export const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TitleText = styled.h2`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #333333;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Text = styled.p`
  font-family: Inter, sans-serif;
  font-size: 16px;
  color: #333333;
  line-height: 1.5;
`;

export const Footer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const PrimaryButton = styled.button`
  background: #2d5bff;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`;

export const SecondaryButton = styled.button`
  background: #ffffff;
  color: #2d5bff;
  border: 1px solid #2d5bff;
  border-radius: 8px;
  padding: 10px 24px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`;
